import type React from 'react'
import { createContext } from 'react'

export const MarketplaceCardContext = createContext<{
  href?: string;
  isClickable: boolean;
  target?: string;
  titleId?: string;
  titleRef: React.Ref<HTMLAnchorElement>;
}>({
  href: undefined,
  isClickable: false,
  target: undefined,
  titleId: undefined,
  titleRef: { current: null },
})
